import { useLayer } from '@coursera-web/statsig';

const SUBSCRIPTIONS_READ_PATH_MIGRATION_LAYER = 'subscriptions_v1_read_path_migration_layer';
const MIGRATION_VARIANT_PARAM = 'migration_variant';
const NAPTIME_VARIANT = 'control';
const GATEWAY_VARIANT = 'enabled';

/**
 * Gates the Subscriptions gateway read path behind the `subscriptions_v1_read_path_migration_layer`
 * Statsig layer (MONETIZE-3022).
 */
const useIsSubscriptionsGatewayMigrationEnabled = (): boolean => {
  const layer = useLayer(SUBSCRIPTIONS_READ_PATH_MIGRATION_LAYER);

  return layer.get(MIGRATION_VARIANT_PARAM, NAPTIME_VARIANT) === GATEWAY_VARIANT;
};

export default useIsSubscriptionsGatewayMigrationEnabled;
